import React from 'react';
import Relay from 'react-relay';

import IconButton from 'react-mdl/lib/IconButton';

import MailingListRow from './MailingListRow/MailingListRow';
import loader from '../../loader';

let _MailingLists = Relay.createContainer(class extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            openDialog: false,
            newLists: [],
        };
    }

    createNewMailingList() {
        this.setState(({newLists}) => ({
            newLists: newLists.concat([Math.random().toString()]),
            loading: false,
        }));
    }

    render() {
        if (this.state.loading) {
            return loader();
        }

        let lists = this.props.root.mailingLists;

        return (
            <table className="mdl-data-table mdl-shadow--2dp" style={{margin: '2em auto 0'}}>
                <thead>
                <tr>
                    <th className="mdl-data-table__cell--non-numeric">
                        <div>
                            <span>Name (Members)</span>
                        </div>
                    </th>
                    <th className="mdl-data-table__cell--non-numeric">
                        <div>
                            <span>Description</span>
                        </div>
                    </th>
                    <th className="mdl-data-table__cell--non-numeric">
                        <div>
                            <span>Address</span>
                        </div>
                    </th>
                    <th className="mdl-data-table__cell--non-numeric">
                        <div>
                            <span>Access Level</span>
                        </div>
                    </th>
                    <th>
                        <div>
                            <IconButton name="refresh" onClick={() => {
                                this.props.relay.forceFetch(null, state => {
                                    if (state.ready) {
                                        this.setState({loading: state.stale});
                                    }
                                });
                            }}/>
                            <IconButton name="add" onClick={() => this.createNewMailingList()}/>
                        </div>
                    </th>
                </tr>
                </thead>
                <tbody>
                {lists.map(list => <MailingListRow key={`list-${list.address}`} mailingList={list} />)}
                {this.state.newLists.map((id) => <MailingListRow key={`new-list-${id}`} mailingList={null}/>)}
                </tbody>
            </table>
        );
    }
}, {
    fragments: {
        root: () => Relay.QL`
            fragment on Query {
                mailingLists {
                    address
                    
                    ${MailingListRow.getFragment('mailingList')}
                }
            }
        `,
    }
});

export default class MailingLists extends React.Component {
    componentWillMount() {
        this.setState({
            route: {
                queries: {
                    root: () => Relay.QL`query { root }`,
                },
                params: {},
                name: 'MailingListsRoute',
            }
        })
    }

    render() {
        return (
            <Relay.RootContainer
                Component={_MailingLists}
                route={this.state.route}
                renderLoading={loader}
            />
        );
    }
};



/** WEBPACK FOOTER **
 ** ./src/Routes/MailingLists/MailingLists.js
 **/